var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.25,
    width: 34.5,
    height: 23.5,
    rx: 2.75,
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.07 12.287c.513.012 1.03-.022 1.541.018.518.097.643.881.183 1.138-.314.17-.688.063-1.028.093h-.697v-1.249zm1.838-1.413c.114.403-.274.765-.662.71h-1.177c.008-.38-.016-.793.012-1.153.471.014.947-.027 1.416.021a.56.56 0 01.411.422zm2.832-5.973c.022.769.003 1.579.01 2.364-.002 3.19.003 6.382-.003 9.573-.02 1.196-1.08 2.235-2.268 2.26-1.19.004-2.378 0-3.567.001v-4.824c1.295-.007 2.591.014 3.886-.01.601-.038 1.26-.434 1.287-1.095.07-.664-.555-1.123-1.15-1.196-.228-.006-.221-.067 0-.093.567-.123 1.012-.71.846-1.297-.142-.618-.825-.857-1.394-.856-1.158-.008-2.317 0-3.475-.003.008-.9-.015-1.802.012-2.702.092-1.175 1.179-2.143 2.35-2.122h3.466z",
    fill: "url(#JCB_svg__paint0_linear_19_2472)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82 7.144c.03-1.194 1.095-2.224 2.281-2.242 1.184-.003 2.37 0 3.553-.001-.003 3.995.007 7.99-.004 11.985-.046 1.18-1.099 2.19-2.272 2.212-1.187.004-2.373 0-3.56.001v-4.987c1.152.273 2.361.389 3.537.208.703-.113 1.472-.458 1.71-1.188.175-.623.077-1.28.103-1.92V9.725h-2.035c-.01.983.018 1.969-.015 2.95-.055.604-.653.988-1.222.967-.706.008-2.106-.511-2.106-.511-.003-1.843.02-4.15.03-5.986z",
    fill: "url(#JCB_svg__paint1_linear_19_2472)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.413 10.325c-.107.023-.021-.365-.049-.512.007-.93-.015-1.86.013-2.79.091-1.179 1.186-2.15 2.362-2.122H21.2c-.003 3.995.007 7.99-.005 11.985-.045 1.18-1.098 2.19-2.272 2.212-1.186.004-2.373 0-3.56.002v-5.464c.81.665 1.912.768 2.922.77.761 0 1.518-.118 2.257-.293v-1.001c-.833.415-1.812.679-2.736.44-.644-.16-1.112-.783-1.101-1.448-.075-.691.33-1.421 1.01-1.627.843-.264 1.763-.062 2.554.282.17.088.341.198.273-.085v-.787c-1.322-.314-2.73-.43-4.058-.088-.385.109-.76.273-1.072.526z",
    fill: "url(#JCB_svg__paint2_linear_19_2472)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__paint0_linear_19_2472",
    x1: 21.872,
    y1: 11.696,
    x2: 27.713,
    y2: 11.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__paint1_linear_19_2472",
    x1: 8.694,
    y1: 12.136,
    x2: 14.559,
    y2: 12.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__paint2_linear_19_2472",
    x1: 15.355,
    y1: 11.834,
    x2: 21.2,
    y2: 11.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
export default SvgJcb;